import { render, staticRenderFns } from "./ResouceCenterService.vue?vue&type=template&id=ad594708"
import script from "./ResouceCenterService.vue?vue&type=script&lang=js"
export * from "./ResouceCenterService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports